// extracted by mini-css-extract-plugin
export default {"particlesOut":"MovingParticles_particlesOut__Bv2K7","particlesIn":"MovingParticles_particlesIn__vTGwy"};